import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["checked", "disabled", "id", "tabIndex"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef, useRef } from 'react';
import styled, { css } from 'styled-components';
import { alpha, contrast, getDimmedTextColor, pxToRem, _3px } from 'utils/ui';
import useMergedRefs from 'hooks/useMergedRefs';
import { useTabIndexContext } from 'components/TabIndexContext';
import { Ok as OkIcon } from 'components/icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Input = styled.input.withConfig({
  displayName: "Switch__Input",
  componentId: "sc-22vum7-0"
})(["position:absolute;opacity:0;"]);
var Wrapper = styled.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'disabled';
  }
}).withConfig({
  displayName: "Switch__Wrapper",
  componentId: "sc-22vum7-1"
})(["position:relative;display:inline-block;width:2.4rem;height:1.4rem;padding:", ";border:1px solid ", ";border-radius:1.4rem;transition:all 250ms linear;box-sizing:border-box;", " &:focus-within{border-color:", ";}"], pxToRem(2), function (p) {
  return alpha(p.theme.shade, 0.3);
}, function (p) {
  return !p.disabled && css(["&:focus-within,&:hover{background:", ";}"], function (p) {
    return alpha(p.theme.shade, p.theme.shadeStrength);
  });
}, function (p) {
  return p.theme.links;
});
var Handle = styled.span.withConfig({
  displayName: "Switch__Handle",
  componentId: "sc-22vum7-2"
})(["display:flex;height:100%;width:50%;border-radius:100%;overflow:hidden;color:", ";background-color:", ";will-change:transform;transition:transform 150ms ease-out;input:checked + &{background-color:", ";transform:translateX(100%);}input:disabled + &{opacity:0.5;}"], function (p) {
  return contrast(p.theme.links);
}, function (p) {
  return getDimmedTextColor(p.theme);
}, function (p) {
  return p.theme.links;
});
var SwitchIcon = styled(OkIcon).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'checked';
  }
}).withConfig({
  displayName: "Switch__SwitchIcon",
  componentId: "sc-22vum7-3"
})(["position:relative;top:", ";left:", ";opacity:0;transform:translateY(-100%) rotate(45deg);will-change:transform,opacity;transition:transform 0s linear 150ms,opacity 100ms linear;", ""], pxToRem(1), pxToRem(1), function (p) {
  return p.checked && css(["opacity:1;transform:none;transition:all 100ms ease-out 150ms;"]);
});
var FocusRing = styled.span.withConfig({
  displayName: "Switch__FocusRing",
  componentId: "sc-22vum7-4"
})(["opacity:0;input.focus-visible ~ &{position:absolute;top:-", ";left:-", ";bottom:-", ";right:-", ";border-radius:inherit;box-shadow:0 0 0 ", " ", ";opacity:1;transition:opacity 100ms linear;}"], _3px, _3px, _3px, _3px, _3px, function (p) {
  return p.theme.links;
});
var Switch = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
    disabled = _ref.disabled,
    id = _ref.id,
    tabIndex = _ref.tabIndex,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var inputRef = useRef(null);
  var mergedRefs = useMergedRefs([ref, inputRef]);
  var tabIndexContext = useTabIndexContext();

  // Forward clicks on the wrapper (handle, icon, focus ring) to the input.
  // We use e.target (the originating element) rather than e.currentTarget
  // (always the wrapper) so that clicks originating from the input itself
  // are not forwarded again — which would cause a double-toggle in React 18,
  // where programmatic .click() calls re-enter the React event system.
  function forwardClick(e) {
    if (inputRef.current && e.target instanceof Node && !inputRef.current.contains(e.target)) {
      inputRef.current.click();
    }
  }
  return /*#__PURE__*/_jsxs(Wrapper, {
    disabled: disabled,
    onClick: forwardClick,
    children: [/*#__PURE__*/_jsx(Input, _objectSpread({
      type: "checkbox",
      ref: mergedRefs,
      id: id,
      checked: checked,
      disabled: disabled,
      tabIndex: tabIndex || tabIndexContext
    }, otherProps)), /*#__PURE__*/_jsx(Handle, {
      children: /*#__PURE__*/_jsx(SwitchIcon, {
        scale: 0.8,
        checked: checked
      })
    }), /*#__PURE__*/_jsx(FocusRing, {})]
  });
});
Switch.displayName = 'Switch';
export default Switch;